import * as Yup from 'yup'
import { PageDescription } from '../../../../../../../_metronic/layout/core';

export interface ICreateActionPlans {
  id?: number;
  uuid?: string;
  conditioning_id?: number;
  provider_id?: number;
  responsible?: string;
  description?: string; 
  action_plan_cost?: string,
  number_months?: number,
  email_responsible?: string,
  predicted_date?: string,
  conclusion_date?: string,
  status?: any,
  alert_days: number[]
  responsible_id?:number [],
 
  conditioning?: {
    id: number;
    uuid: string;   
    provider_id: 41,
    conditioning_number: number,
    license: {
      id: number,
      uuid: string,     
      license_number: string
    }
  
  },
  responsibles?: [
    {
      id: number,      
      username: string,
      firstname: string,       
    }
  ],
  provider?: {
    id: number,
    uuid: string,
    name: string,   
  }, 

  path?: [
    {
      name: string
      size: string
    }
  ]

  project_id?: number

}


const createActionPlansSchemas = [
  Yup.object({
    
  }),

  Yup.object({
    description: Yup.string().required('Campo obrigatório'),
    responsible_id: Yup.array().required('Campo obrigatório') 
  }),
  Yup.object({
    predicted_date: Yup.string().required('Campo obrigatório'),
    conclusion_date: Yup.string().required('Campo obrigatório'),
    alert_days: Yup.array().required('Campo obrigatório')
  }) 
]


const inits : ICreateActionPlans = { 
  alert_days: [],
  description: '',
  
}

export {createActionPlansSchemas,inits}
